import {assert} from 'Asserts';

import {SimpleRule, SimpleRuleInput} from './types';

export function getInputForSimpleRule(
  simpleRules: Array<SimpleRule>,
  validationRuleTemplateId: string,
  inputKey: string
): SimpleRuleInput | null {
  const simpleRule = simpleRules.find((rule) => rule.validationRuleTemplateId === validationRuleTemplateId);
  if (!simpleRule) {
    return null;
  }
  assert(
    simpleRule.constantInputs.hasOwnProperty(inputKey),
    `Input key '${inputKey}' not found in simple rule.`
  );
  return simpleRule.constantInputs[inputKey];
}

export function doesSimpleRuleExist(
  simpleRules: Array<SimpleRule>,
  validationRuleTemplateId: string
): boolean {
  const simpleRule = simpleRules.find((rule) => rule.validationRuleTemplateId === validationRuleTemplateId);
  return simpleRule != null;
}
